<button
  mat-flat-button
  [disabled]="disabled()"
  class="{{ buttonTheme() }} "
  (click)="buttonClick.emit($event)"
  type="{{ buttonType() }}"
>
  <div class="caption-container">
    @if (buttonIcon()) {
      <div class="button-icon" [ngClass]="buttonIconPosition()">
        <mat-icon [svgIcon]="buttonIcon()"></mat-icon>
      </div>
    }
    <span>{{ buttonCaption() }} </span>
    @if (showSpinner()) {
      <span><mat-spinner [diameter]="20"></mat-spinner></span>
    }
  </div>
</button>
